<template>
  <Suspense>
    <div class="app">
      <div id="app-top-anchor"></div>
      <RouterView />
    </div>
    <template #fallback> Loading... </template>
  </Suspense>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { RouterView } from 'vue-router'

import { useContentStore } from '@/stores/content'
import { mapStores } from 'pinia'

import {
  navBatchItems,
  pageMetaTitlesBatchItems,
  processingLabelsBatchItems,
  sharedMessagesBatchItems
} from '@/lib/contentKeys'

export default defineComponent({
  name: 'App',
  components: {
    RouterView
  },
  computed: {
    ...mapStores(useContentStore)
  },
  beforeMount() {
    console.log('Version: ' + __APP_VERSION__)
  },
  created() {
    this.contentStore.fetchBatch([
      ...sharedMessagesBatchItems,
      ...processingLabelsBatchItems,
      ...navBatchItems,
      ...pageMetaTitlesBatchItems
    ])
  }
})
</script>

<style lang="scss">
:root {
  --popper-theme-background-color: #{$color-white};
  --popper-theme-background-color-hover: #{$color-white};
  --popper-theme-text-color: #{$color-gray-300};
  --popper-theme-border-width: 1px;
  --popper-theme-border-style: solid;
  --popper-theme-border-radius: 6px;
  --popper-theme-padding: 1rem;
  --popper-theme-box-shadow: 0 6px 30px -6px rgba(0, 0, 0, 0.25);
}
</style>

<style lang="scss" scoped>
.app {
  background-color: $color-white;
}
</style>
